var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99858 15.6271L8.40969 16.9875C8.32742 17.351 8.27778 17.7409 8.27778 18.1111C8.27778 20.9636 10.5919 23.2778 13.4444 23.2778C15.6389 23.2778 17.506 21.8943 18.2424 19.944L24.1917 21.7017L24.8333 21.8913V21.2222V2.55556V1.8814L24.1882 2.07708L4.00314 8.19956C3.65625 7.81104 3.16742 7.5 2.55556 7.5C1.39433 7.5 0.5 8.46321 0.5 9.55555V14.2222C0.5 15.3734 1.40441 16.2778 2.55556 16.2778C3.14889 16.2778 3.64021 16.0139 3.99858 15.6271ZM11.6111 18.1111C11.6111 18.045 11.6142 17.9821 11.6206 17.9197L15.028 18.9682C14.7186 19.5478 14.1118 19.9444 13.4444 19.9444C12.4081 19.9444 11.6111 19.1475 11.6111 18.1111ZM28.2222 0.5H26.6667C25.9332 0.5 25.3889 1.13302 25.3889 1.77778V22C25.3889 22.7136 25.953 23.2778 26.6667 23.2778H28.2222C28.867 23.2778 29.5 22.7335 29.5 22V1.77778C29.5 1.42072 29.3265 1.10551 29.1105 0.889502C28.8945 0.673496 28.5793 0.5 28.2222 0.5Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2);
export default __webpack_public_path__ + "static/media/s2.5851870383997e944dbdb20f51a5080e.svg";
export { ForwardRef as ReactComponent };